import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { rem } from 'polished'
import styled from 'styled-components'
import { mediaQueryUp } from 'components/utils/breakpoint'
import LoyaltyAccountLandingPageYourBenefits from './LoyaltyAccountLandingPageYourBenefits'
import useCurrentLoyaltyTier from 'loyalty/hooks/useCurrentLoyaltyTier'
import LoyaltyAccountLandingPageUserActivities from './LoyaltyAccountLandingPageUserActivities'
import LoyaltyLandingPageNextTierBenefitsContent from './LoyaltyLandingPageNextTierBenefitsContent'
import StatusMatchChallengeCard from 'loyalty/pages/statusMatch/StatusMatchChallengeCard'
import { useAppSelector } from 'hooks/reduxHooks'

const Section = styled(VerticalSpacer)`
  padding: ${rem(24)} 0;

  ${mediaQueryUp.tablet} {
    padding: ${rem(48)} 0;
  }
`

function LoyaltyAccountBenefitsProgressContent() {
  const [, , nextTier] = useCurrentLoyaltyTier()
  const benefits = useAppSelector(state => state.loyalty.account.data?.benefits)
  const hasBenefits = !!benefits?.length

  return <Section gap={24}>
    <StatusMatchChallengeCard />
    {hasBenefits && <LoyaltyAccountLandingPageYourBenefits />}
    {nextTier && <LoyaltyLandingPageNextTierBenefitsContent nextTier={nextTier} />}
    <LoyaltyAccountLandingPageUserActivities />
  </Section>
}

export default LoyaltyAccountBenefitsProgressContent
